import { render, staticRenderFns } from "./ChooseApprovers.vue?vue&type=template&id=4a935685&scoped=true&"
import script from "./ChooseApprovers.vue?vue&type=script&lang=js&"
export * from "./ChooseApprovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a935685",
  null
  
)

export default component.exports